export const PARENT_DAILY_SCHEDULE = '/api/v1/journals/schedules/for-parent/daily';
export const PARENT_WEEKLY_SCHEDULE = '/api/v1/journals/schedules/for-parent/weekly';
export const PARENT_INDIVIDUAL_SCHEDULE = '/api/v1/timetables/for-parent/weekly';
